










































import { Component, Vue } from "vue-property-decorator";

function getShuffledArr<T>(arr: T[]): T[] {
  const newArr = arr.slice();
  for (let i = newArr.length - 1; i > 0; i--) {
    const rand = Math.floor(Math.random() * (i + 1));
    [newArr[i], newArr[rand]] = [newArr[rand], newArr[i]];
  }
  return newArr;
}

enum CardType {
  Text,
  Image,
}

interface Card {
  id: number;
  pairId: number;
  type: CardType;
  content: string;
  tapped: boolean;
  correct: boolean;
  resolved: boolean;
}

@Component
export default class Memory extends Vue {
  private CardType = CardType;
  private cardTypeCount = 2;

  private cardData = [
    {
      title: "Le Capitole",
      image: "capitole-2",
    },
    {
      title: "Couvent des Jacobins",
      image: "jacobins",
    },
    {
      title: "Canal du Midi",
      image: "canal",
    },
    {
      title: "Le Pont-Neuf",
      image: "pont-neuf",
    },
    {
      title: "Office de Tourisme",
      image: "office-de-tourisme",
    },
    {
      title: "Rue Saint-Rome",
      image: "rue-saint-rome",
    },
    {
      title: "Port de la Daurade",
      image: "port-de-la-daurade",
    },
    {
      title: "Centrale Hydro&shy;électrique Bazacle",
      image: "edf-bazacle",
    },
    {
      title: "Cité de l'Espace",
      image: "cite-de-espace",
    },
    {
      title: "Airbus St. Martin",
      image: "airbus-st-martine",
    },
  ];

  private cards: Card[] = [];
  private tappedCards: Card[] = [];
  private resetLocked = false;
  private startTime: number | null = null;
  private lastTapTime: number | null = null;
  private playMoves = 0;

  private getImgUrl(name: string) {
    const images = require.context(
      "@/assets/dynamic/memory/",
      false,
      /\.(png|jpg)$/
    );
    try {
      return images("./" + name + ".jpg");
    } catch (error) {
      try {
        return images("./" + name + ".png");
      } catch (error) {
        return images("./missing-image.png");
      }
    }
  }

  private reseed() {
    const cards: Card[] = [];
    const addCard = (
      id: number,
      pairId: number,
      type: CardType,
      content: string
    ) => {
      cards.push({
        id,
        pairId,
        type,
        content,
        tapped: false,
        correct: false,
        resolved: false,
      });
    };

    for (const [i, element] of this.cardData.entries()) {
      addCard(i * 2, i, CardType.Text, element.title);
      addCard(i * 2 + 1, i, CardType.Image, this.getImgUrl(element.image));
    }

    this.cards = getShuffledArr(cards);
  }

  private sortCards() {
    this.cards.sort((a, b) => (a.id == b.id ? a.type - b.type : a.id - b.id));
  }

  private reset() {
    if (this.resetLocked) {
      return;
    }

    this.resetLocked = true;
    this.cards.forEach((card) => {
      card.tapped = false;
      card.correct = false;
      card.resolved = false;
    });

    this.startTime = null;
    this.lastTapTime = null;
    this.playMoves = 0;

    setTimeout(() => {
      this.reseed();
      this.resetLocked = false;
    }, 1000);

    this.tappedCards = [];
  }

  mounted() {
    this.reseed();
  }

  get totalCards() {
    return this.cardData.length;
  }

  get completedCards() {
    return this.cards.filter((card) => card.resolved).length / 2;
  }

  get solved() {
    return this.cards.every((card) => card.resolved);
  }

  get playTime() {
    if (this.startTime !== null && this.lastTapTime !== null) {
      const difference = this.lastTapTime - this.startTime;
      const minutes = Math.floor(difference / 1000 / 60);
      const seconds = Math.floor(difference / 1000) - minutes * 60;
      return ("0" + minutes).slice(-2) + ":" + ("0" + seconds).slice(-2);
    }
    return "??:??";
  }

  private checkTappedCards(): boolean {
    if (this.tappedCards.length != this.cardTypeCount) {
      return false;
    }
    const pairId = this.tappedCards[0].pairId;
    return this.tappedCards.every((card) => card.pairId === pairId);
  }

  private tap(card: Card) {
    if (this.resetLocked || this.solved) {
      return;
    }

    this.lastTapTime = Date.now();
    if (this.startTime === null) {
      this.startTime = this.lastTapTime;
    }

    if (!this.checkCompletion()) {
      if (card.tapped == false) {
        card.tapped = true;
        this.tappedCards.push(card);

        if (this.checkTappedCards()) {
          this.tappedCards.forEach((card) => (card.correct = true));
        }
      }
    }
  }

  private checkCompletion(): boolean {
    if (this.resetLocked || this.solved) {
      return false;
    }

    if (this.tappedCards.length == this.cardTypeCount) {
      if (this.checkTappedCards()) {
        this.tappedCards.forEach((card) => (card.resolved = true));
      } else {
        this.tappedCards.forEach((card) => (card.tapped = false));
      }
      this.tappedCards = [];
      this.playMoves++;

      if (this.solved) {
        this.sortCards();
      }
      return true;
    }
    return false;
  }
}
